import React from 'react';
import { Divider, Typography } from 'fronton-react';
import { dimensionsAtom } from 'pages/dimensions/store/dimensions';
import { useRecoilValue } from 'recoil';
import { useCalculationState } from 'pages/calculation/store/calculation';
import { sortComplimentaryProductsByPrice } from 'pages/common/helpers/sort-complimentary-products-by-price';
import { AddedProductsTitle, ComplementaryProductsBox, ComplimentaryProductInfoContainer } from './styles';
import { MainProduct } from './MainProduct';
import { ComplementaryProduct } from './ComplementaryProduct';
import { useRobotintMutationObserver } from './hooks';

export const ComplementaryProductsComponent = () => {
  const dimensions = useRecoilValue(dimensionsAtom);
  const { complimentaryProductInfo, complimentaryGroups } = dimensions;
  const { complimentaryProducts, totalComplimentaryProductCount } = useCalculationState();
  useRobotintMutationObserver();

  return (
    <ComplementaryProductsBox>
      <MainProduct />
      {!!totalComplimentaryProductCount && (
        <>
          <AddedProductsTitle>
            <Typography variant="h3">Подобрали инструменты и расходники</Typography>
          </AddedProductsTitle>
          <ComplimentaryProductInfoContainer>
            {complimentaryProductInfo.map((item, i) => (
              <>
                <ComplementaryProduct product={item} index={i} key={item.productId} />
                {totalComplimentaryProductCount - 1 !== i && <Divider />}
              </>
            ))}
            {complimentaryGroups.map((group, i) => {
              const item = group.products.find(product => product.productId in complimentaryProducts);

              return item ? (
                <>
                  <ComplementaryProduct
                    product={item}
                    index={i + complimentaryProductInfo.length}
                    key={item.productId}
                    variants={sortComplimentaryProductsByPrice(group.products)}
                  />
                  {complimentaryGroups.length - 1 !== i && <Divider />}
                </>
              ) : null;
            })}
          </ComplimentaryProductInfoContainer>
        </>
      )}
    </ComplementaryProductsBox>
  );
};
